<template>
    <b-card-body
        :body-bg-variant="bodyBgColor"
        :body-text-variant="bodyTextColor"
    >
        <slot />
    </b-card-body>
</template>

<script>
// Components.
import {BCardBody} from 'bootstrap-vue'

export default {
    components: {BCardBody},
    props: {
        bodyBgColor: {type: String},
        bodyTextColor: {type: String},
    },
}
</script>